// «Назад» в Mini App — кнопка Telegram в заголовке. На сайте стрелку рисует сам экран.
import { useEffect, useRef } from "react";
import { useChannel } from "./channel";

export function useTelegramBackButton(onBack: (() => void) | null): void {
  const channel = useChannel();
  const latestBack = useRef(onBack);
  useEffect(() => {
    latestBack.current = onBack;
  }, [onBack]);

  const webApp = channel.kind === "telegram" ? channel.webApp : null;
  const hasBack = onBack !== null;
  useEffect(() => {
    if (webApp === null || !hasBack) {
      return;
    }
    const handleBack = () => latestBack.current?.();
    webApp.BackButton.onClick(handleBack).show();
    return () => {
      webApp.BackButton.offClick(handleBack).hide();
    };
  }, [webApp, hasBack]);
}
